import { createRoutine } from 'redux-saga-routines';
import { ME_RETRIEVE } from './types';

// eslint-disable-next-line import/prefer-default-export
export const retrieveMe = createRoutine(ME_RETRIEVE);
